module.exports = __webpack_public_path__ + "img/DC-Logo-Web-Color-StackedTagline.1722b30.png";